import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";

const TREND_ENDPOINT: keyof paths = '/api/Item/GetTrend';

export type ProfileTrendRequest = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemTrendRequest"];
export type ProfileTrendResponseItem = components["schemas"]["FlavorTracker.Entities.DTO.ItemPage.ItemTrendChartDataByMetric"];
export type ProfileTrendResponse = ProfileTrendResponseItem[];

export function useProfileTrend(payload: ProfileTrendRequest): {
    isLoading: boolean;
    data: ProfileTrendResponse;
} {
    const response = useAxios<ProfileTrendResponse, ProfileTrendRequest>({
        url: TREND_ENDPOINT,
        method: 'post',
        payload,
    });

    return {
        ...response,
        data: response.data ?? [],
    };
}